import * as React from 'react';
import { UserDataDispatcher } from './UserDataDispatcher';
import { UserDispatcher } from './UserDispatcher';
import { QueryParamsDispatcher } from './QueryParamsDispatcher';
import {ClientInfoDispatcher} from './ClientInfoDispatcher';
import { ThreeDataDispatcher } from './ThreeDataDispatcher';

interface CombinedDispacherProps {
}

const CombinedDispacher: React.SFC<CombinedDispacherProps> = (props) => {
  return (
    <>
      <ClientInfoDispatcher />
      <QueryParamsDispatcher />
      <UserDataDispatcher />
      <UserDispatcher />
    </>
  );
};

export default CombinedDispacher;